module.exports = __webpack_public_path__ + "img/icon_package5.e8c4e443.png";